import { ContactName } from '@uplift/types';
import { useL10n } from '@uplift/hooks';
import { Key } from '@uplift/icons';
import { userContactsQueryKey, useUserContactsQuery } from '@uplift/queries';
import { BaseDashboardActionItem, PhoneVerificationModal } from '@uplift/ui-v2';
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export type SetUp2faProps = {
  userId: string;
};

export const SetUp2fa: React.VFC<SetUp2faProps> = ({ userId }) => {
  const l10n = useL10n();
  const queryClient = useQueryClient();
  const [ isModalOpen, setIsModalOpen ] = useState(false);

  const { data: contacts = [] } = useUserContactsQuery(userId);
  const mobileContact = contacts.find(x => x.name === ContactName.mobile);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    queryClient.invalidateQueries(userContactsQueryKey(userId));
    queryClient.invalidateQueries({ queryKey: [ 'allActionItems' ] });
  };

  return (
    <>
      <BaseDashboardActionItem
        title={l10n.dashboard.actionItems.addMfa.title}
        details={l10n.dashboard.actionItems.addMfa.subtitle}
        color="info"
        icon={<Key />}
        action={{
          handleClick: () => setIsModalOpen(true),
          text: l10n.dashboard.actionItems.addMfa.buttonText
        }}
      />
      <PhoneVerificationModal
        open={isModalOpen}
        onClose={handleCloseModal}
        userId={userId}
        phone={mobileContact?.value}
        contactId={mobileContact?.id}
        contactName={ContactName.mobile}
        maskPhone
        title={l10n.phoneValidationModal.verifyYourNumber}
        successText={l10n.phoneValidationModal.mobileNumberVerified}
      />
    </>
  );
};
